var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "gap-2 text-sm" },
    [
      _c(
        "div",
        {
          staticClass: "flex transform hover:text-purple-500 cursor-pointer",
          on: {
            click: function ($event) {
              return _vm.$emit("message")
            },
            mouseover: function ($event) {
              _vm.isHoveredChat = true
            },
            mouseout: function ($event) {
              _vm.isHoveredChat = false
            },
          },
        },
        [
          !_vm.isHoveredChat
            ? _c("MessageIcon", { staticClass: "w-4 h-4" })
            : _vm._e(),
          _vm.isHoveredChat
            ? _c("MessageIconHover", { staticClass: "w-4 h-4" })
            : _vm._e(),
        ],
        1
      ),
      _c("RouterLink", { attrs: { to: _vm.requestLink } }, [
        _c(
          "div",
          {
            staticClass: "flex transform hover:text-purple-500",
            on: {
              mouseover: function ($event) {
                _vm.isHoveredView = true
              },
              mouseout: function ($event) {
                _vm.isHoveredView = false
              },
            },
          },
          [
            !_vm.isHoveredView
              ? _c("ViewIcon", { staticClass: "w-4 h-4" })
              : _vm._e(),
            _vm.isHoveredView
              ? _c("ViewIconHover", { staticClass: "w-4 h-4" })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex transform hover:text-purple-500" }, [
        _c(
          "button",
          {
            on: {
              click: _vm.toggleRequestModal,
              mouseover: function ($event) {
                _vm.isHoveredEdit = true
              },
              mouseout: function ($event) {
                _vm.isHoveredEdit = false
              },
            },
          },
          [
            !_vm.isHoveredEdit
              ? _c("EditIcon", { staticClass: "w-4 h-4" })
              : _vm._e(),
            _vm.isHoveredEdit
              ? _c("EditIconHover", { staticClass: "w-4 h-4" })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }